








import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Tabs from './Tabs.vue';


const STORAGE_KEY = '_farms-home-tab-open'

@Component({
   name: 'TabsController',
   components: {
     Tabs,
   }
})
export default class TabsController extends Vue {
  private activeTab: string = '';

  private created() {
    const activeTab = localStorage.getItem(STORAGE_KEY);
    this.activeTab = activeTab ? JSON.parse(activeTab) : '';
  }

  private persistActiveTab(payload: string) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch {}
  }
}
